import React, {useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Icon,
} from "@material-ui/core"

// Components
import Button from "../../../../components/Button"

// Styles
import useStyles from "./styles"

// HOCs
import withRecords, {WithRecordsProps} from "../../hoc/withRecords"
import usePrevious from "../../../../hooks/usePrevious"

type Props = WithRecordsProps

const InitDialog = (props: Props) => {
    const {currentRecord, fetchingRecord} = props;
    const [isActive, setIsActive] = useState(false)
    const styles = useStyles();
    const [t] = useTranslation("common");
    const prevFetchingRecord = usePrevious(fetchingRecord)

    useEffect(() => {
        if (typeof prevFetchingRecord === "undefined" && prevFetchingRecord !== fetchingRecord && !fetchingRecord && currentRecord !== null) {
            setIsActive(true)
        }
    }, [fetchingRecord, currentRecord])

    const handleClose = () => {
        setIsActive(false)
    }

    const getYesOrNo = (state: boolean) => {
        if (state) {
            return t("init_modal.yes")
        }

        return t("init_modal.no")
    }

    if (currentRecord === null) {
        return null
    }

    return (
        <React.Fragment>
            <Icon
                color="primary"
                className={styles.info_icon}
                onClick={() => setIsActive(true)}
            >
                info
            </Icon>
            <Dialog
                open={isActive}
                onClose={handleClose}
                PaperProps={{className: styles.wrapper}}
            >
                <DialogTitle className={styles.title}>
                    {t("init_modal.title")}
                </DialogTitle>
                <DialogContent>
                    {currentRecord.metaData.reason ? (
                        <React.Fragment>
                            <Typography className={styles.item_label}>
                                {t("init_modal.reason")}:
                            </Typography>
                            <Typography component="p">
                                {currentRecord.metaData.reason.split("%20").join(" ")}
                            </Typography>
                        </React.Fragment>
                    ) : (
                        <Box className={styles.item}>
                            <Typography className={styles.item_label}>
                                {t("init_modal.reason")}:
                            </Typography>
                            <Typography component="p">
                                -
                            </Typography>
                        </Box>
                    )}
                    <Box className={styles.item}>
                        <Typography className={styles.item_label}>
                            {t("init_modal.antihypertensive")}:
                        </Typography>
                        <Typography component="p">
                            {getYesOrNo(currentRecord.metaData.antihypertensive)}
                        </Typography>
                    </Box>
                    <Box className={styles.item}>
                        <Typography className={styles.item_label}>
                            {t("init_modal.diabetes")}:
                        </Typography>
                        <Typography component="p">
                            {getYesOrNo(currentRecord.metaData.diabetes)}
                        </Typography>
                    </Box>
                    <Box className={styles.item}>
                        <Typography className={styles.item_label}>
                            {t("init_modal.dyslipidemia")}:
                        </Typography>
                        <Typography component="p">
                            {getYesOrNo(currentRecord.metaData.dyslipidemia)}
                        </Typography>
                    </Box>
                    <Box className={styles.item}>
                        <Typography className={styles.item_label}>
                            {t("init_modal.pacemaker")}:
                        </Typography>
                        <Typography component="p">
                            {getYesOrNo(currentRecord.metaData.pacemaker)}
                        </Typography>
                    </Box>
                    {currentRecord.metaData.note ? (
                        <React.Fragment>
                            <Typography className={styles.item_label}>
                                {t("init_modal.note")}:
                            </Typography>
                            <Typography component="p">
                                {currentRecord.metaData.note.split("%20").join(" ")}
                            </Typography>
                        </React.Fragment>
                    ) : (

                        <Box className={styles.item}>
                            <Typography className={styles.item_label}>
                                {t("init_modal.note")}:
                            </Typography>
                            <Typography component="p">
                                -
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions className={styles.actions}>
                    <Button
                        size="medium"
                        color="primary"
                        variant="outlined"
                        label="Ok"
                        onClick={handleClose}
                        className={styles.footer_button}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default withRecords(InitDialog)
